import { render } from "./driver-update.vue?vue&type=template&id=c5127dcc&scoped=true"
import script from "./driver-update.vue?vue&type=script&lang=js"
export * from "./driver-update.vue?vue&type=script&lang=js"

import "./driver-update.vue?vue&type=style&index=0&id=c5127dcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5127dcc"]])

export default __exports__